<template>
  <div class="UpdateStudentCom" style="margin-right: 10px">
    <el-button type="text" size="small" @click="showDialog">编辑</el-button>
    <el-dialog
      :center="true"
      custom-class="el__dialog"
      :visible.sync="flag"
      title="编辑学生信息"
      :lock-scroll="true"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :before-close="studentFields"
      top="0"
      width="40%"
    >
      <p class="dialog__content__title">学生信息：</p>
      <el-form
        :model="student"
        ref="student"
        :rules="studentRules"
        label-width="100px"
      >
        <el-form-item label="姓名" class="el__item"  prop="name">
          <el-input
            style="width: 280px"
            v-model.trim="student.name"
            placeholder="学生姓名"
          />
        </el-form-item>
        <el-form-item label="学籍号" class="el__item" prop="rosterNo">
          <el-input
            style="width: 280px"
            v-model.trim="student.rosterNo"
            placeholder="学籍号"
          />
        </el-form-item>
        <el-form-item label="身份证号" class="el__item" prop="idCard">
          <el-input
            style="width: 280px"
            v-model.trim="student.idCard"
            placeholder="身份证号"
          />
        </el-form-item>
        <el-form-item label="年级" class="el__item" prop="gradeId">
          <el-select
            v-model="student.gradeId"
            placeholder="请选择年级"
            @change="changeclassesList"
            style="width: 280px"
          >
            <el-option
              v-for="item in gradeList"
              :key="item.gradeId"
              :label="item.name"
              :value="item.gradeId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班级" class="el__item" prop="classesId">
          <el-select
            :disabled="student.gradeId == ''"
            v-model="student.classesId"
            style="width: 280px"
            placeholder="请选择班级"
          >
            <el-option
              v-for="item in classesList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别" class="el__item">
          <el-select
            v-model="student.sex"
            style="width: 280px"
            placeholder="请选择性别"
          >
            <el-option :value="0" label="男"></el-option>
            <el-option :value="1" label="女"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="民族" class="el__item">
          <el-select v-model="student.nation" filterable style="width: 280px">
            <el-option
              v-for="item in nationList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生日" class="el__item">
          <el-date-picker
            v-model="student.birth"
            value-format="yyyy-MM-dd"
            style="width: 280px"
          />
        </el-form-item>
        <el-form-item label="政治面貌" class="el__item">
          <!-- <el-input
            v-model="student.politics"
            style="width:280px;"
            placeholder="政治面貌"
          /> -->
          <el-select
            v-model="student.political"
            style="width: 280px"
            filterable
          >
            <el-option
              v-for="item in politicsList"
              :key="item.id"
              :label="item.name"
              :value="Number(item.code)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="籍贯" class="el__item">
          <el-input
            v-model.trim="student.nativePlace"
            style="width: 280px"
            placeholder="籍贯"
          />
        </el-form-item>
        <el-form-item label="家庭住址" class="el__item">
          <el-input
            v-model.trim="student.address"
            type="textarea"
            style="width: 280px"
          />
        </el-form-item>
      </el-form>
      <p class="dialog__content__title">家长信息：</p>
      <el-form
        :model="parent"
        ref="parent"
        label-width="100px"
      >
        
        <el-form-item label="家长姓名" class="el__item" prop="name">
          <el-input
            v-model.trim="parent.name"
            style="width: 280px"
            placeholder="家长姓名"
          />
        </el-form-item>
        <el-form-item label="手机号" class="el__item" prop="mobile">
          <el-input
            v-model.trim="parent.mobile"
            style="width: 280px"
            placeholder="手机号"
          />
        </el-form-item>
        <el-form-item label="家长角色" class="el__item" prop="relation">
          <el-select clearable v-model="parent.relation" style="width: 280px" filterable>
            <el-option
              v-for="item in relationList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <footer class="dialog__footer" slot="footer">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="hidedialogflag">取消</el-button>
          <el-button size="small" type="primary" @click="Submit('student')"
            >确定</el-button
          >
        </el-row>
      </footer>
    </el-dialog>
  </div>
</template>
<script>
import { studentCheckParent, saveStudent, dictCode } from '@/api/home'

export default {
  name: 'UpdateStudentCom',
  props: {
    relationList: {
      type: Array,
    },
    gradeList: {
      type: Array,
    },
    nationList: {
      type: Array,
    },
    studentObj: {
      type: Object,
    },
    parentList: {
      type: Array,
    },
    classes: {
      type: Object,
    },
  },
  data() {
    const checkphone = (rule, value, callback) => {
      let reg = /^(?:(?:\+|00)86)?1\d{10}$/
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      } else if (!reg.test(value)) {
        callback(new Error('请填写正确的手机'))
      } else {
        studentCheckParent({ phone: value })
          .then(() => {
            callback()
          })
          .catch((error) => {
            return callback(new Error(error))
          })
      }
    }
    const checkidCard = (rule, value, callback) => {
      let _id_reg = /^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}[\dXx]$/
     if (value && !_id_reg.test(value)) {
        callback(new Error('请填写正确的身份证号'))
      } else {
        callback()
      }
    }
    return {
      flag: false,
      student: {
        id: '',
        name: '', // 姓名
        rosterNo: '', // 学籍号
        address: '', // 家庭住址
        birth: '', // 生日
        idCard: '', // 身份证号码
        nation: '汉族', // 民族
        nativePlace: '', // 籍贯
        political: '', // 政治面貌
        sex: '', // 性别
        gradeId: '', // 年级
        classesId: '', // 班级
        schoolId: localStorage.getItem('userId'),
      },
      // parent: {
      //   name: '',
      //   mobile: '',
      //   relation: '',
      //   schoolId: localStorage.getItem('userId'),
      // },
      politicsList: [],
      parent: {
        // schoolId:localStorage.getItem('userId'),
        name: '',
        mobile: '',
        relation: '',
      },
      // classesList: [],
      studentRules: {
        name: [
          {
            required: true,
            message: '姓名不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        rosterNo: [
          {
            required: true,
            message: '学籍号不能为空',
            trigger: ['blur'],
          },
          {
            min: 6,
            message: '学籍号至少6位及以上',
            trigger: ['blur'],
          },
        ],
        idCard: [
          {
            required: false,
            validator: checkidCard,
            trigger: ['blur'],
          },
        ],
        gradeId: [
          {
            required: true,
            message: '年级不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        classesId: [
          {
            required: true,
            message: '班级不能为空',
            trigger: ['blur', 'change'],
          },
        ],
      },
    }
  },
  computed: {
    classesList() {
      let _arr = []
      this.gradeList.forEach((k) => {
        if (k.gradeId == this.student.gradeId) {
          _arr = k.classesList
          return _arr
        }
      })
      return _arr
    },
  },
  watch: {
    $props: {
      deep: true,
      immediate: true,
      handler() {
        this.student = { ...this.studentObj, ...this.classes }
        // this.student.parent = this.parentList[0] || this.parent
        this.parent = { ...this.parentList[0] }
      },
    },
  },
  mounted() {
    this.type = localStorage.getItem('type')
    if (this.type == 8) {
      // 更改校验规则
      this.studentRules.rosterNo = [
         {
            required: true,
            message: '学员编号不能为空',
            trigger: ['blur'],
          },
          {
            min: 6,
            message: '学员编号至少6位及以上',
            trigger: ['blur'],
          },
      ]
    }
  },
  methods: {
    studentFields(){
      this.flag = false
      this.$refs.student.resetFields()
    },
    showDialog() {
      this.dictCode()
      this.flag = true
    },
    hidedialogflag() {
      this.flag = false
      this.resetForm('student')
      this.resetForm('parent')
      this.student = { ...this.studentObj, ...this.classes }
      // this.student.parent = this.parentList[0] || this.parent
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    changeclassesList() {
      this.student.classesId = ''
    },
    ApiSaveStudent() {
      let data = {}
      if (
        !this.parent.name  ||
        !this.parent.mobile  ||
        !this.parent.relation 
      ) {
        data = {
          classesId: this.student.classesId,
          gradeId: this.student.gradeId,
          student: { ...this.student },
        }
      } else {
        data = {
          classesId: this.student.classesId,
          gradeId: this.student.gradeId,
          student: { ...this.student },
          parent: {
            ...this.parent,
            schoolId:localStorage.getItem('schoolIds')
          },
        }
      }
      saveStudent({ ...data }).then((res) => {
        if (res.data.code !== '0') {
          return false
        }
        this.hidedialogflag()
        this.$message({
          message: '修改成功',
          type: 'success',
        })
        this.$emit('updateList')
      })
    },

    // 字典  查询政治面貌
    async dictCode() {
      const { data: res } = await dictCode({
        code: 'political_type',
      })
      this.politicsList = res.data
    },
    Submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.parent.name || this.parent.mobile || this.parent.relation) {
              if (!(/^1[0-9]{10}$/.test(this.parent.mobile))) {
                console.log(this.parent.mobile);
                this.$message.error('请填写正确的家长手机号哦！')
                return false
              }
            if (this.parent.name == '' || this.parent.name==null) {
              this.$message.error('家长姓名是必填的哦！')
              return false
            } else if (this.parent.mobile == '' || this.parent.mobile==null) {
              this.$message.error('家长手机号是必填的哦！')
              return false
            } else if (this.parent.relation == '' || this.parent.relation==null) {
              this.$message.error('关系是必选的哦！')
              return false
            }
          }
          console.log('this.parent.relation',this.parent.relation);
          this.ApiSaveStudent()
          this.$refs[formName].resetFields()
        } else {
          this.$message.error('请检查信息是否填写正确')
          return false
        }
      })
    },
  },
}
</script>
<style scoped>
.UpdateStudentCom {
  display: inline-block;
}
.UpdateStudentCom .el-form-item {
  margin: 20px 0;
}
.UpdateStudentCom .el-input__inner {
  width: 100%;
}
.el__dialog.el-dialog {
  max-height: 90vh;
  overflow: auto;
  margin: 5vh auto !important;
}
.el-button {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/school/components/components/updateStudent.vue